"use client";

import type { OnboardingWizardStep } from "@/src/components/OnboardingWizard/types";
import { WIZARD_STEP_ORDER } from "@/src/components/OnboardingWizard/types";
import { clearOnboardingV3Session } from "./onboardingV3SessionStorage";

const SESSION_KEY = "onboarding_wizard_furthest_step";

/** Paywall 前已越过 goal、尚未 paywall 落定的步骤 */
const INTERRUPT_RESET_STEPS: ReadonlySet<OnboardingWizardStep> = new Set([
  "loading",
  "loading-error",
  "fitness-score-result",
  "result",
]);

const isBrowser = () => typeof window !== "undefined";

const parseWizardStep = (raw: string | null): OnboardingWizardStep | null => {
  if (!raw) {
    return null;
  }
  return WIZARD_STEP_ORDER.includes(raw as OnboardingWizardStep)
    ? (raw as OnboardingWizardStep)
    : null;
};

export const persistWizardFurthestStep = (step: OnboardingWizardStep): void => {
  if (!isBrowser()) {
    return;
  }
  const current = parseWizardStep(sessionStorage.getItem(SESSION_KEY));
  const currentIdx = current ? WIZARD_STEP_ORDER.indexOf(current) : -1;
  const nextIdx = WIZARD_STEP_ORDER.indexOf(step);
  if (nextIdx > currentIdx) {
    sessionStorage.setItem(SESSION_KEY, step);
  }
};

export const getWizardFurthestStep = (): OnboardingWizardStep | null =>
  isBrowser() ? parseWizardStep(sessionStorage.getItem(SESSION_KEY)) : null;

export const clearWizardSession = (): void => {
  if (!isBrowser()) {
    return;
  }
  sessionStorage.removeItem(SESSION_KEY);
  clearOnboardingV3Session();
};

export const shouldResetWizardForInterrupt = (): boolean => {
  const furthest = getWizardFurthestStep();
  return furthest ? INTERRUPT_RESET_STEPS.has(furthest) : false;
};
